<div class="REF-sh-Step1popup">

    <button class="REF-sh-steps-cross" (click)="close()">
        <img src="assets/img/filter-close-icon.png" class="REF-sh-steps-crossimg" alt="" />
    </button>

    <h3 class="REF-sh-popup-heading mt-2">Share</h3>
    <div class="REF-sh-shareic-wrp">
        <!--Code start-->
        <button class="REF-sh-socimg-h" mat-fab [url]="rootUrl" shareButton="whatsapp" [url]="rootUrl"
            (click)="sendModeOfShare('whatsapp')">
            <div class="REF-sh-icon-outer">
                <i class="fab fa-whatsapp REF-shwhatsapp-ic"></i>
            </div>
            <span class="REF-sh-socl-text">Whatsapp</span>
        </button>

        <button class="REF-sh-socimg-h" mat-fab shareButton="facebook" [url]="textAreaLink"
            (click)="sendModeOfShare('facebook')">
            <!-- [url]="rootUrl" -->
            <div class="REF-sh-icon-outer">
                <i class="fab fa-facebook-f REF-sh-fb-ic"></i>
            </div>
            <span class="REF-sh-socl-text">Facebook</span>
        </button>

        <button class="REF-sh-socimg-h" mat-fab shareButton="twitter" [url]="rootUrl"
            (click)="sendModeOfShare('twitter')">
            <div class="REF-sh-icon-outer">
                <i class="fab fa-twitter REF-sh-tweet-ic"></i>
            </div>
            <span class="REF-sh-socl-text">Twitter</span>
        </button>

        <button class="REF-sh-socimg-h" mat-fab shareButton="linkedin" [url]="textAreaLink"
            (click)="sendModeOfShare('linkedin')">
            <div class="REF-sh-icon-outer">
                <i class="fab fa-linkedin-in REF-sh-linkedin-ic"></i>
            </div>
            <span class="REF-sh-socl-text">Linkedin</span>
        </button>

        <button class="REF-sh-socimg-h" mat-fab shareButton="pinterest" [url]="textAreaLink"
            (click)="sendModeOfShare('pinterest')">
            <div class="REF-sh-icon-outer">
                <i class="fab fa-pinterest-p REF-sh-pinterest-ic"></i>
            </div>
            <span class="REF-sh-socl-text">Pinterest</span>
        </button>

        <button class="REF-sh-socimg-h" mat-fab shareButton="reddit" [url]="rootUrl"
            (click)="sendModeOfShare('reddit')">
            <div class="REF-sh-icon-outer">
                <i class="fab fa-reddit REF-sh-reddit-ic"></i>
            </div>
            <span class="REF-sh-socl-text">Reddit</span>
        </button>

        <button class="REF-sh-socimg-h" mat-fab shareButton="xing" [url]="rootUrl" (click)="sendModeOfShare('xing')">
            <div class="REF-sh-icon-outer">
                <i class="fab fa-xing REF-sh-xing-ic"></i>
            </div>
            <span class="REF-sh-socl-text">Xing</span>
        </button>

        <button class="REF-sh-socimg-h" mat-fab shareButton="email" [url]="rootUrl" (click)="sendModeOfShare('email')">
            <div class="REF-sh-icon-outer">
                <i class="fas fa-envelope REF-sh-email-ic"></i>
            </div>
            <span class="REF-sh-socl-text">Email</span>
        </button>
        <!--Code ends-->
    </div>

    <p class="REF-sh-sharingtext">Sharing this link with your friends and earn Infinity Coins</p>
    <div class="REF-sh-socialwrpp">
        <div class="REF-sh-copytext-cont">
            <input type="text" name="" [value]="textAreaLink" class="REF-sh-writerinput" />
            <button (click)="copyRefCode()" type="button" class="REF-sh-copybtn"><img
                    src="assets/img/CYOT-copy-blue.svg" alt=""></button>
        </div>
    </div>
</div>